import { call } from 'redux-saga/effects';
import { AesCm256EncryptionKey } from 'features/e2ee/AesCm256EncryptionKey';
import { E2EEManager } from 'features/e2ee/E2EEManager';
import { exchangeCreatedWhiteboardKeySaga } from 'features/e2ee/sagas/exchangeCreatedWhiteboardKeySaga';

export function* createBoardKeySaga(whiteboardId: string, roomId: string) {
  const created: AesCm256EncryptionKey = yield call(
    E2EEManager.whiteboard.generateKey,
    whiteboardId,
    roomId
  );

  if (!created.encryptionKey) {
    throw new Error(`Whiteboard key generation produced no key id=${whiteboardId}`);
  }

  yield call(exchangeCreatedWhiteboardKeySaga, whiteboardId);

  return created.encryptionKey;
}
